export default "__VITE_PUBLIC_ASSET__904f3ec9__"